package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_08_08_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The river flows from the mountains of Ladikor north into the sea in Freeburg harbor, so the first leg of the journey is by foot alongside the river. The heroes notice a lot of Greycloaks as they leave, and they suspect that Prudence’s Barrowmen organization is larger than they previously appreciated. At the city gate, the guards warn the heroes to stay close to the river due to recent aggressive behavior of Dorvidian border guards.")
    }
}
